import {HypothesisFilesColumns} from "../types/hypothesis-modal.types";
import {resources} from "../../../../models/resource/resources";
import {HypothesisFileTypeName} from "../../../../types/file.types";
import {HYPOTHESIS_FILE_TYPES} from "../../../../constants/files.const";

export const hypothesisModalName = 'hypothesis';

export const hypothesisFilesPath = 'hypothesis-files';
export const hypothesisResourceType = resources['hypotheses'];

export const hypothesisModalColumn: Array<HypothesisFilesColumns> = [
  {
    title: 'Первая фаза',
    fileType: 'FIRST_PHASE',
    inputName: 'firstPhaseComment'
  },
  {
    title: 'Вторая фаза',
    fileType: 'SECOND_PHASE',
    inputName: 'secondPhaseComment'
  },
  {
    title: 'Третья фаза',
    fileType: 'THIRD_PHASE',
    inputName: 'thirdPhaseComment'
  },
]

export function isHypothesisFileType(fileType: string | undefined): fileType is HypothesisFileTypeName {
  return fileType !== undefined &&
    HYPOTHESIS_FILE_TYPES.includes(fileType as HypothesisFileTypeName);
}
